export default {};
//# sourceMappingURL=de.js.map